import { PropsWithChildren, useEffect } from 'react'
import { COOKIE_CONSENT_STATUS_KEY, COOKIE_CONSENT_STATUS_QUERY_PARAM_KEY } from 'utils/constants'

function CookieConsentHandler({ children }: PropsWithChildren) {
  useEffect(() => {
    const currentUrl = new URL(window.location.href)
    const cookieConsentStatus = currentUrl.searchParams.get(COOKIE_CONSENT_STATUS_QUERY_PARAM_KEY)

    if (cookieConsentStatus === 'granted') {
      localStorage.setItem(COOKIE_CONSENT_STATUS_KEY, cookieConsentStatus)
    }

    function removeConsentStatus() {
      localStorage.removeItem(COOKIE_CONSENT_STATUS_KEY)
    }

    window.addEventListener('beforeunload', removeConsentStatus)

    return () => {
      window.removeEventListener('beforeunload', removeConsentStatus)
    }
  }, [])

  return children
}

export { CookieConsentHandler }
